import { updateMediaDeviceAction } from "../../actions/webrtc";
import { API_UPDATE_RING_MEDIA_DEVICE } from "../../constants/events";
import Emitter from "../../emitter";
import storeRTK from "../../store/storeRTK";

export const registerMediaHandlers = () => {
  Emitter.on(API_UPDATE_RING_MEDIA_DEVICE, (ev) => {
    try {
      if (ev.body?.deviceId) {
        storeRTK.dispatch(updateMediaDeviceAction(ev.body?.deviceId));
      }
    } catch (error) {
      console.error(error);
    }
  });
};
